import { combineReducers } from 'redux';
import estructura from './estructura';
import dades from './dades';
import idEstacioSeleccionada from './idEstacioSeleccionada';
import peticioEnviarFormulariEnCurs from './peticioEnviarFormulariEnCurs';
import peticioObtenirEstructuraEnCurs from './peticioObtenirEstructuraEnCurs';
import peticioObtenirEstructuraIDadesEnCurs from './peticioObtenirEstructuraIDadesEnCurs';
import mostrarErrors from './mostrarErrors';

export default combineReducers({
    idEstacioSeleccionada,
    estructura,
    dades,
    peticioEnviarFormulariEnCurs,
    peticioObtenirEstructuraEnCurs,
    peticioObtenirEstructuraIDadesEnCurs,
    mostrarErrors
});



// WEBPACK FOOTER //
// ./src/reducers/estacio/formulari/index.js